import * as Msdyn365 from '@msdyn365-commerce/core';

export interface IPaging {
    top: number;
    skip: number;
}

/**
 * Input Action
 */
export class GetOrderHistoryInput implements Msdyn365.IActionInput {
    public userToken: string;
    public timestamp: string;
    public top: number;
    public skip: number;

    constructor(ctx: Msdyn365.ICreateActionContext, top = 10, skip = 0) {
        this.userToken = ctx.requestContext.user.token;
        this.timestamp = new Date().getTime().toString();
        this.top = top;
        this.skip = skip;
    }

    public getCacheKey = () => `GetOrderShipmentsHistory-${this.userToken}-${this.timestamp}`;
    public getCacheObjectType = () => 'GetOrderShipmentsHistory';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IOrderShipment {
    SalesId: string;
    CreatedDateTime: string;
    TotalAmount: number;
    CustomerRequisition?: string;
    Comment?: string;
    RequestedReceiptDate?: string;
}

export interface IOrderShipmentsHistoryResponse {
    '@odata.context'?: string;
    value: IOrderShipment[];
    error?: {
        errorCode: number;
        errorText: string;
    };
}

/**
 * Input Factory
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetOrderHistoryInput(args);
};

/**
 * Action
 */
async function action(input: GetOrderHistoryInput, ctx: Msdyn365.IActionContext): Promise<IOrderShipmentsHistoryResponse> {
    const url = `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetOrderShipmentsHistory?$top=${input.top}&$skip=${input.skip}`;

    const response = await Msdyn365.sendRequest<IOrderShipmentsHistoryResponse>(
        url,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            },
            timeout: 30000
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return {
        value: [],
        error: {
            errorCode: response.status,
            errorText: response.statusText
        }
    };
}

export default Msdyn365.createObservableDataAction({
    id: 'GetOrderShipmentsHistory',
    action: <Msdyn365.IAction<IOrderShipmentsHistoryResponse>>action,
    input: createInput
});
